<!-- Content -->
<div class="flex w-full items-center justify-between">
  <!-- Desktop Filters -->
  <div class="hidden flex-nowrap gap-3 md:flex">
    <ng-content select="[desktopFilters]"></ng-content>
  </div>
  <!-- Mobile Layout -->
  <div class="flex w-full items-center gap-3 md:hidden">
    <dhp-mobile-filter-dialog
      [articleAmount]="articleAmount()"
      (resetFilters)="resetFilters.emit()"
    >
      <ng-content select="[mobileFilters]"></ng-content>
    </dhp-mobile-filter-dialog>
  </div>
</div>
